import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { memo } from "react";
import { RotatingDowntick } from "~/components/RotatingDowntick";
import { LIST_SECTION_TITLE } from "~/constants/testIDs";
export const ListSectionHeader = /*#__PURE__*/ memo((param)=>{
    let { className, collapsed = false, headerTitle, onClick, children, showDowntick = "hover-only", ...rest } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("relative flex items-end justify-between pb-4", className),
        ...rest,
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                appearance: "ghost",
                color: "grey",
                className: classNames("group/list-section-header -ml-2", !!onClick ? "cursor-pointer" : "cursor-default"),
                size: "small",
                onClick: onClick,
                "data-testid": LIST_SECTION_TITLE,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative bg-transparent text-12 font-bold uppercase text-grey-10",
                        children: headerTitle
                    }),
                    !!onClick && /*#__PURE__*/ _jsx("div", {
                        className: classNames("pointer-events-none ml-1 group-hover/list-section-header:opacity-100", showDowntick === "hover-only" ? "opacity-0" : "opacity-100"),
                        children: /*#__PURE__*/ _jsx(RotatingDowntick, {
                            rotate: collapsed
                        })
                    })
                ]
            }),
            children
        ]
    });
});
ListSectionHeader.displayName = "ListSectionHeader";
